import { Fragment, useEffect, useState } from "react";
import { filterHandler } from "../../services/helpers";

import { Table, Icon, Alert } from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";

const ClientDocumentPhrasesConfigurationTable = ({
  items,
  columns,
  phrasesModalOpenHandler,
  confirmModalOpenHandler,
  getClientDocumentFieldConfigs,
}) => {
  const [results, setResults] = useState(null);

  useEffect(() => {
    setResults(items);
  }, [items]);

  return (
    <Fragment>
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Ricerca per nome del campo"}
            column={"notificationTargetFieldLabel"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getClientDocumentFieldConfigs()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.notificationTargetFieldId}>
                    <td className="notificationTargetFieldLabel">
                      {result.notificationTargetFieldLabel}
                    </td>
                    <td className="beginKeyPhrase">{result.beginKeyPhrase}</td>
                    <td className="endKeyPhrase">{result.endKeyPhrase}</td>
                    <td className="keyPattern">{result.keyPattern}</td>
                    <td className="actions text-center">
                      <span title="Configura campo" className="mr-2">
                        <Icon
                          id="edit-client"
                          icon="it-pencil"
                          fill="#06c"
                          role="button"
                          onClick={(e) => phrasesModalOpenHandler(result)}
                        />
                      </span>

                      <span title="Rimuovi frasi">
                        <Icon
                          id="delete-configuration"
                          icon="it-delete"
                          fill="#005A9A"
                          role="button"
                          onClick={(e) => confirmModalOpenHandler(result)}
                        />
                      </span>
                    </td>
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </Fragment>
  );
};

export default ClientDocumentPhrasesConfigurationTable;
